export default {
    defaultOutputParams: {
        realtime: {
            cron: 'cron("* * * * *")'
        },
        historical: {
            cron: 'cron("* * * * *")'
        }
    },
    allTypes: ['realtime', 'historical']
}
